import { useMutation, useQuery } from '@tanstack/react-query';
import { store } from '../..';
import { queryClient } from '../../..';
import { setAlert, setIsLoading } from '../../components/components-slice';
import { nsitfApis } from './../../../api/payroll/statutory-compliance/nsitf';
import moment from 'moment';
import { formatNumber } from '../../../utils/functions';

export function useGetNsitfHistory(limit, page, statusFilter, search) {
  return useQuery(
    ['nsitf', { limit, page, statusFilter, search }],
    () => {
      store.dispatch(setIsLoading(true));
      return nsitfApis.getNSITF({
        limit,
        page,
        statusFilter,
        search,
      });
    },
    {
      select(data) {
        data?.data?.forEach((nsitf) => {
          nsitf.created = moment(nsitf.created).format('MMMM DD, YYYY');
          nsitf.month = moment(nsitf.month).format('MMMM, YYYY');
          nsitf.status = parseFloat(nsitf.nsitf_status)
          if (nsitf.status === 2) {
            nsitf.status = 0
          }
          switch (nsitf.status) {
            case 0:
              nsitf.computedActions = [0];
              break;
            case 1:
              nsitf.computedActions = [1];
              break;
            default:
              break;
          }
        });

        return data;
      },
      onSettled: (data, error, variables, context) => {
        store.dispatch(setIsLoading(false));
      },
      // keepPreviousData: true
    },
  );
}

export function useUploadNsitf() {
  return useMutation(
    (payload) => {
      return nsitfApis.bulkNSITF(payload);
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries('nsitf');
        store.dispatch(setAlert(true, 'success', 'Upload Successful'));
      },
      onSettled: (data, error, variables, context) => {
        store.dispatch(setIsLoading(false));
      },
    },
  );
}

export function useRefNSITF(refId, limit, page, search) {
  return useQuery(
    ['nsitf-by-ref', { refId, limit, page, search }],
    () => {
      store.dispatch(setIsLoading(true));
      return nsitfApis.fetchNSITFByRef({refId, limit, page, search});
    },
    {
      select: (data) => {
        data?.data?.forEach((item) => {
          item.employeeName = `${item.first_name} ${item.last_name}`;
          if (!item.status) {
            item.status = 0
          }
          item.formatted_amount = formatNumber(parseFloat(item.amount.toFixed(2)), 2);
        });
        if (data) {
          data.formatted_total_amount = formatNumber(parseFloat(data?.total_amount.toFixed(2)), 2);
          data.formatted_total_trans_cost = formatNumber(parseFloat(data?.total_trans_cost.toFixed(2)), 2);
          data.formatted_total_payable = formatNumber(parseFloat(data?.total_payable.toFixed(2)), 2);
        }
        return data;
      },
      onSettled: (data, error, variables, context) => {
        store.dispatch(setIsLoading(false));
      },
    },
  );
}